(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["asa-contact-normalizer"] && !Shopify.designMode) return;
  try {
    (() => {
  const phone = '555135634811';
  const visiblePhone = /(?:\+?55[\s.\-]*)?(?:\(?51\)?[\s.\-]*)?3563[\s.\-]*4811/g;
  const oldEmails = ['contato@darkseagreen-hamster-817078.hostingersite.com', 'contato@asasportsoficial.com.br', 'atendimento@asasports.com.br'];
  const correctEmail = 'contato@asasports.com.br';
  const clean = value => (value || '').replace(/\s+/g, ' ').trim();
  const pageTitle = () => clean(document.querySelector('.asa-page-heading h1,.product-information h1,.asa-collection-header h1,main h1')?.textContent) || clean(document.title.replace(/\s*[|–-]\s*ASA.*$/i, '')) || 'ASA Sports';
  const usefulHeading = element => {
    if (element.closest?.('footer')) return '';
    const ignored = /^(contato|fone|telefone|whatsapp|fone\s*\/\s*whatsapp|fale conosco|atendimento)$/i;
    const scopes = ['article', '.asa-mvv-card', '.asa-valor', '.asa-one__card', '.asa-detail-card', '.asa-editorial-segment', '.section', 'aside', 'section'];
    for (const selector of scopes) {
      const scope = element.closest?.(selector);
      if (!scope) continue;
      const headings = [...scope.querySelectorAll('h2,h3,h4,h5')]
        .map(item => clean(item.textContent))
        .filter(item => item && !ignored.test(item) && !/3563\D*4811/.test(item) && !/@/.test(item));
      if (headings.length) return headings[0];
    }
    return '';
  };
  const whatsappUrl = element => {
    // Sociedades Recreativas: preservar o texto comercial da landing page
    // em todos os botões, inclusive os do cabeçalho e rodapé da loja.
    if (window.location.pathname === '/pages/uniformes-sociedades-recreativas') {
      const hero = document.querySelector('[data-asa-soc-wa-message]');
      const message = hero?.getAttribute('data-asa-soc-wa-message') || 'Olá! Sou da diretoria de uma sociedade recreativa e quero agendar o diagnóstico gratuito de uniformes para os departamentos do clube.';
      return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    }
    if (window.location.pathname === '/pages/sociedade-ginastica-novo-hamburgo') {
      const message = document.querySelector('[data-sgnh-message]')?.getAttribute('data-sgnh-message') || 'Olá! Vi a coleção Sociedade Ginástica Novo Hamburgo no site da ASA Sports e gostaria de mais informações sobre os uniformes e a possibilidade de solicitar um orçamento.';
      return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    }
    const title = pageTitle();
    const subject = usefulHeading(element);
    const message = subject && subject !== title
      ? `Olá! Estou na página "${title}" e gostaria de mais informações sobre "${subject}".`
      : `Olá! Estou na página "${title}" e gostaria de atendimento pelo WhatsApp.`;
    return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  };
  const normalizeEmails = root => {
    root.querySelectorAll?.('a[href^="mailto:"]').forEach(link => {
      const current = (link.getAttribute('href') || '').toLowerCase();
      if (oldEmails.some(email => current.includes(email.toLowerCase()))) {
        link.href = `mailto:${correctEmail}`;
        if (oldEmails.some(email => clean(link.textContent).toLowerCase().includes(email.toLowerCase()))) link.textContent = correctEmail;
      }
    });
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(node => {
      if (node.parentElement?.closest('script,style,textarea,input,option')) return;
      let value = node.nodeValue || '';
      let changed = false;
      oldEmails.forEach(email => {
        if (value.toLowerCase().includes(email.toLowerCase())) {
          value = value.replace(new RegExp(email.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi'), correctEmail);
          changed = true;
        }
      });
      if (changed) node.nodeValue = value;
    });
  };
  const normalizeExistingPhoneLinks = root => {
    root.querySelectorAll?.('a[href^="tel:"],a[href*="wa.me/"],a[href*="api.whatsapp.com/send"]').forEach(link => {
      const href = link.getAttribute('href') || '';
      const digits = href.replace(/\D/g, '');
      if (!href.startsWith('tel:') && !digits.includes(phone)) return;
      link.href = whatsappUrl(link);
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      visiblePhone.lastIndex = 0;
      if (visiblePhone.test(clean(link.textContent))) link.classList.add('asa-phone-whatsapp');
      visiblePhone.lastIndex = 0;
    });
  };
  const wrapPhoneText = root => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(node => {
      const parent = node.parentElement;
      if (!parent || parent.closest('a,script,style,noscript,textarea,input,option')) return;
      const value = node.nodeValue || '';
      visiblePhone.lastIndex = 0;
      if (!visiblePhone.test(value)) return;
      visiblePhone.lastIndex = 0;
      const fragment = document.createDocumentFragment();
      let cursor = 0;
      for (const match of value.matchAll(visiblePhone)) {
        if (match.index > cursor) fragment.append(document.createTextNode(value.slice(cursor, match.index)));
        const link = document.createElement('a');
        link.className = 'asa-phone-whatsapp';
        link.href = whatsappUrl(parent);
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = match[0];
        fragment.append(link);
        cursor = match.index + match[0].length;
      }
      if (cursor < value.length) fragment.append(document.createTextNode(value.slice(cursor)));
      node.replaceWith(fragment);
    });
  };
  const enhance = root => {
    const scope = root?.nodeType === Node.DOCUMENT_NODE ? document.body : root;
    if (!scope) return;
    normalizeEmails(scope);
    normalizeExistingPhoneLinks(scope);
    wrapPhoneText(scope);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance(document), { once: true });
  else enhance(document);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  let queued = false;
  const observer = new MutationObserver(records => {
    if (queued || !records.some(record => record.addedNodes.length)) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      enhance(document);
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["asa-final-polish"] && !Shopify.designMode) return;
  try {
    (() => {
  const base='https://cdn.shopify.com/s/files/1/0817/4292/1969/files/';
  const migratedLogos=new Map([
    ['https://asasports.com.br/wp-content/uploads/2025/10/4.jpg',base+'dd5437ca_4.jpg?v=1790105291'],
    ['https://asasports.com.br/wp-content/uploads/2025/10/6.jpg',base+'78087bf8_6.jpg?v=1790105298']
  ]);
  function enhance(root=document){
    root.querySelectorAll('asa-legacy-page').forEach(editorial=>{
      const seen=new Set();
      editorial.querySelectorAll('.asa-editorial-logos img').forEach(img=>{const src=migratedLogos.get(img.src)||img.src;img.src=src;if(seen.has(src))img.remove();else seen.add(src);});
      editorial.querySelectorAll('.elementor-gallery__container>a').forEach(a=>{
        if(a.dataset.asaGalleryReady)return;a.dataset.asaGalleryReady='true';
        const original=a.href;if(!/^https?:/.test(original))return;
        const old=a.querySelector('[data-thumbnail]');const img=document.createElement('img');
        img.src=original;img.alt=a.dataset.elementorLightboxTitle||editorial.closest('.asa-page')?.querySelector('h1')?.textContent||'ASA Sports';
        img.loading='lazy';img.decoding='async';img.width=Number(old?.dataset.width)||800;img.height=Number(old?.dataset.height)||600;
        img.addEventListener('error',()=>{img.hidden=true;const message=document.createElement('span');message.className='asa-media-missing';message.textContent=img.alt;a.append(message);},{once:true});
        a.replaceChildren(img);a.dataset.asaZoom='';a.setAttribute('aria-label',editorial.dataset.zoomLabel||img.alt);
      });
      editorial.querySelectorAll('.htmega-button a').forEach(a=>a.classList.add('asa-action'));
      editorial.querySelectorAll('.asa-editorial-gallery h3').forEach(h=>{if(h.textContent.trim()==='Conj. Futebol Dold')h.textContent='Conjunto de Fardamento GOLD';});
    });
    root.querySelectorAll("[id$='__asa_footer'] a").forEach(a=>{if(a.textContent.trim()==='Pra Corrida')a.href='/collections/pra-corrida';});
    root.querySelectorAll('.asa-line-card').forEach(a=>{
      const text=a.querySelector('span')?.textContent.trim();
      if(['Casual','Corporativo','Acess\u00f3rios'].includes(text)&&a.getAttribute('href')==='/pages/catalogo')a.href='/pages/fale_conosco?produto='+encodeURIComponent(text);
    });
  }
  function start(root=document){requestAnimationFrame(()=>enhance(root));if(root.querySelector('asa-legacy-page'))customElements.whenDefined('asa-legacy-page').then(()=>requestAnimationFrame(()=>enhance(root)));}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>start(),{once:true});else start();
  document.addEventListener('shopify:section:load',e=>start(e.target));
})();

(() => {
  const phone='555135634811';
  const normalize=value=>(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/\s+/g,' ').trim();
  const pageRoot=()=>document.querySelector('.asa-page');
  const currentLabel=()=>{
    const root=pageRoot();
    const kind=normalize(root?.dataset.asaPage||location.pathname);
    const title=(document.querySelector('.product-information h1,.asa-collection-header h1,.asa-page-heading h1,main h1')?.textContent||document.title||'ASA Sports').trim();
    const source=normalize(kind+' '+title);
    if(location.pathname.includes('/products/'))return {type:'produto',label:title};
    if(location.pathname.includes('/collections/'))return {type:'linha',label:title};
    if(source.includes('futebol'))return {type:'linha',label:'Futebol'};
    if(source.includes('ciclismo'))return {type:'linha',label:'Ciclismo'};
    if(source.includes('hipismo'))return {type:'linha',label:'Hipismo'};
    if(source.includes('fitness')||source.includes('corrida'))return {type:'linha',label:'Pra Corrida / Fitness'};
    if(source.includes('corporativo'))return {type:'linha',label:'Corporativo'};
    if(source.includes('casual'))return {type:'linha',label:'Casual'};
    if(source.includes('acessor'))return {type:'linha',label:'Acessórios'};
    if(source.includes('personaliza')||source.includes('logo')||source.includes('gola')||source.includes('acabamento'))return {type:'personalizacao',label:'Personalização'};
    if(source.includes('detalhes'))return {type:'detalhes',label:'Detalhes dos Uniformes'};
    if(source.includes('tabela')||source.includes('medida'))return {type:'medidas',label:'Tabela de Medidas'};
    if(source.includes('privacidade'))return {type:'privacidade',label:'Política de Privacidade'};
    if(source.includes('contato')||source.includes('fale'))return {type:'contato',label:'Contato'};
    if(source.includes('sobre')||source.includes('missao')||source.includes('visao')||source.includes('valores'))return {type:'sobre',label:'Sobre a ASA'};
    return {type:'geral',label:title};
  };
  const messageFor=()=>{
    const c=currentLabel();
    if(c.type==='produto')return 'Olá! Estou vendo o produto '+c.label+' no site da ASA Sports e gostaria de mais informações e orçamento.';
    if(c.type==='linha')return 'Olá! Estou vendo a linha '+c.label+' da ASA Sports e gostaria de solicitar um orçamento.';
    if(c.type==='personalizacao')return 'Olá! Estou vendo as opções de personalização da ASA Sports e gostaria de ajuda com meu projeto.';
    if(c.type==='detalhes')return 'Olá! Estou vendo os detalhes e acabamentos dos uniformes ASA Sports e gostaria de mais informações.';
    if(c.type==='medidas')return 'Olá! Estou consultando a tabela de medidas da ASA Sports e gostaria de ajuda com os tamanhos.';
    if(c.type==='privacidade')return 'Olá! Estou na Política de Privacidade da ASA Sports e gostaria de falar com a equipe.';
    if(c.type==='contato')return 'Olá! Vi o contato da ASA Sports no site e gostaria de atendimento.';
    if(c.type==='sobre')return 'Olá! Estou conhecendo melhor a ASA Sports pelo site e gostaria de falar com a equipe.';
    return 'Olá! Estou no site da ASA Sports e gostaria de falar com a equipe.';
  };
  const whatsappHref=()=> 'https://wa.me/'+phone+'?text='+encodeURIComponent(messageFor());
  const upgradePhoneLinks=(root=document)=>{
    root.querySelectorAll('a[href^="tel:"]').forEach(a=>{
      const digits=(a.getAttribute('href')||'').replace(/\D/g,'');
      if(!digits.endsWith('5135634811'))return;
      a.href=whatsappHref();a.target='_blank';a.rel='noopener noreferrer';a.classList.add('asa-whatsapp-number');
    });
  };
  const wrapPlainPhones=(root=document)=>{
    const pattern=/(?:\+?55[\s.-]*)?(?:\(?51\)?[\s.-]*)3563[\s.-]*4811/g;
    const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,{acceptNode(node){
      const p=node.parentElement;
      if(!p||p.closest('a,script,style,textarea,input,button,select,option,code,pre'))return NodeFilter.FILTER_REJECT;
      pattern.lastIndex=0;return pattern.test(node.nodeValue||'')?NodeFilter.FILTER_ACCEPT:NodeFilter.FILTER_REJECT;
    }});
    const nodes=[];while(walker.nextNode())nodes.push(walker.currentNode);
    nodes.forEach(node=>{
      pattern.lastIndex=0;
      const frag=document.createDocumentFragment();let last=0;let m;
      while((m=pattern.exec(node.nodeValue||''))){
        frag.append((node.nodeValue||'').slice(last,m.index));
        const a=document.createElement('a');a.href=whatsappHref();a.target='_blank';a.rel='noopener noreferrer';a.className='asa-whatsapp-number';a.textContent=m[0];frag.append(a);last=m.index+m[0].length;
      }
      frag.append((node.nodeValue||'').slice(last));node.replaceWith(frag);
    });
  };
  const makeCards=(editorial,labels,className)=>{
    const wanted=labels.map(normalize);
    const headings=[...editorial.querySelectorAll('h2,h3,h4,h5,h6')].filter(h=>{
      if(h.closest('.asa-principles-grid,.asa-benefit-grid,article,details'))return false;
      const value=normalize(h.textContent);
      return wanted.some(x=>value===x||value.startsWith(x+' '));
    });
    const byParent=new Map();
    headings.forEach(h=>{const p=h.parentElement;if(!p)return;(byParent.get(p)||byParent.set(p,[]).get(p)).push(h);});
    byParent.forEach(list=>{
      if(list.length<2)return;
      const parent=list[0].parentElement;
      const grid=document.createElement('div');grid.className=className;parent.insertBefore(grid,list[0]);
      list.forEach((heading,index)=>{
        if(!heading.isConnected)return;
        const article=document.createElement('article');
        const badge=document.createElement('span');badge.className='asa-card-index';badge.textContent=String(index+1).padStart(2,'0');article.append(badge);
        let node=heading;
        while(node){
          const next=node.nextSibling;
          if(node!==heading&&node.nodeType===1&&/^H[2-6]$/.test(node.tagName)){
            const value=normalize(node.textContent);
            if(wanted.some(x=>value===x||value.startsWith(x+' ')))break;
          }
          article.append(node);node=next;
        }
        grid.append(article);
      });
    });
  };
  const enhanceEditorial=(root=document)=>{
    root.querySelectorAll('asa-legacy-page').forEach(editorial=>{
      if(editorial.dataset.asaCardsReady)return;
      editorial.dataset.asaCardsReady='true';
      const segments=editorial.querySelectorAll(':scope > .asa-editorial-segment');
      if((editorial.textContent||'').trim().length>1800||segments.length>=4)editorial.classList.add('asa-editorial--long');
      const kind=normalize(editorial.closest('.asa-page')?.dataset.asaPage||'');
      if(kind.includes('sobre_a_asa')||kind.includes('missao_visao_valores')){
        makeCards(editorial,['Missão','Visão','Valores'],'asa-principles-grid');
        makeCards(editorial,['Atendimento consultivo','Padronização de verdade','Mais agilidade','Menos erros e retrabalho','Mais praticidade'],'asa-benefit-grid');
      }
    });
  };
  const enhance=(root=document)=>{enhanceEditorial(root);upgradePhoneLinks(root);wrapPlainPhones(root);};
  const start=(root=document)=>{requestAnimationFrame(()=>enhance(root));customElements.whenDefined('asa-legacy-page').then(()=>requestAnimationFrame(()=>enhance(root)));};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>start(),{once:true});else start();
  document.addEventListener('shopify:section:load',e=>start(e.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["asa-legacy-page"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('asa-legacy-page'))customElements.define('asa-legacy-page',class extends HTMLElement{
  connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';if(document.readyState==='loading'){this._ready=()=>this.build();document.addEventListener('DOMContentLoaded',this._ready,{once:true});}else this.build();}
  disconnectedCallback(){document.removeEventListener('DOMContentLoaded',this._ready);if(this.dialog){this.dialog.remove();this.dialog=null;}}
  build(){
    if(!this.isConnected)return;
    this.querySelectorAll('script,style,template,pre.ti-widget,[data-src*="trustindex"]').forEach(n=>n.remove());
    this.querySelectorAll('[style]').forEach(n=>n.removeAttribute('style'));
    this.querySelectorAll('*').forEach(n=>{[...n.attributes].filter(a=>a.name.startsWith('on')).forEach(a=>n.removeAttribute(a.name));});
    const imported=this.querySelector(':scope > .elementor');
    if(imported){
      const rebuilt=document.createElement('div');
      [...imported.children].forEach(segment=>{
        const widgets=[...segment.querySelectorAll('.elementor-widget')].filter(w=>!w.parentElement.closest('.elementor-widget'));
        const out=document.createElement('section');out.className='asa-editorial-segment';if(segment.id)out.id=segment.id;
        let cards=null;
        const appendCard=card=>{if(!cards){cards=document.createElement('div');cards.className='asa-editorial-cards';out.append(cards);}cards.append(card);};
        widgets.forEach(widget=>{
          if(widget.querySelector('.ti-widget,[data-src*="trustindex"]')||widget.classList.contains('elementor-widget-shortcode'))return;
          const accordions=widget.querySelectorAll('.elementor-accordion-item,.single_accourdion');
          if(accordions.length){cards=null;accordions.forEach(item=>{const title=item.querySelector('.elementor-tab-title,.htmega-items-hedding');const answer=item.querySelector('.elementor-tab-content,.accordion-content');if(!title||!answer)return;const details=document.createElement('details');const summary=document.createElement('summary');const copy=title.cloneNode(true);copy.querySelectorAll('svg,i,.elementor-accordion-icon,.accourdion-icon').forEach(n=>n.remove());summary.textContent=copy.textContent.trim();const body=document.createElement('div');body.innerHTML=answer.innerHTML;details.append(summary,body);out.append(details);});return;}
          if(widget.querySelector('.jet-carousel__item')){cards=null;const grid=document.createElement('div');grid.className='asa-editorial-gallery';widget.querySelectorAll('.jet-carousel__item').forEach(item=>{const a=item.querySelector('a'),img=item.querySelector('img'),h=item.querySelector('.jet-carousel__item-title');if(!img)return;const card=document.createElement('article');const link=a?a.cloneNode(false):document.createElement('div');link.append(img.cloneNode(true));if(h){const title=document.createElement('h3');title.textContent=h.textContent.trim();link.append(title);}card.append(link);grid.append(card);});out.append(grid);return;}
          if(widget.querySelector('.exad-logo-carousel')){cards=null;const grid=document.createElement('div');grid.className='asa-editorial-logos';const seen=new Set();widget.querySelectorAll('img').forEach(image=>{let src=image.getAttribute('src');if(src==='https://asasports.com.br/wp-content/uploads/2025/10/4.jpg')src='https://cdn.shopify.com/s/files/1/0817/4292/1969/files/dd5437ca_4.jpg?v=1790105291';if(!src||seen.has(src))return;seen.add(src);const img=image.cloneNode(true);img.src=src;grid.append(img);});out.append(grid);return;}
          const info=widget.querySelector('.ha-infobox-body,.exad-iconbox-content,.exad-infobox-content');
          if(info){const card=document.createElement('article');card.innerHTML=info.innerHTML;appendCard(card);return;}
          if(widget.classList.contains('ha-step-flow')){const card=document.createElement('article');widget.querySelectorAll('.ha-steps-label,.ha-steps-title,.ha-step-description').forEach(n=>card.append(n.cloneNode(true)));appendCard(card);return;}
          cards=null;
          const body=widget.querySelector(':scope > .elementor-widget-container')||widget;
          if(widget.classList.contains('elementor-widget-image')){const image=body.querySelector('img');if(image){const figure=document.createElement('figure');figure.className='asa-editorial-image';figure.append(image.cloneNode(true));out.append(figure);}return;}
          if(widget.classList.contains('elementor-widget-button')||widget.classList.contains('elementor-widget-exad-exclusive-button')){const link=body.querySelector('a[href]');if(link){const row=document.createElement('div');row.className='asa-editorial-buttons';const copy=link.cloneNode(true);copy.className='asa-action';row.append(copy);out.append(row);}return;}
          [...body.childNodes].forEach(n=>out.append(n.cloneNode(true)));
        });
        if(!widgets.length){[...segment.childNodes].forEach(n=>out.append(n.cloneNode(true)));}
        if(out.textContent.trim()||out.querySelector('img,video,table'))rebuilt.append(out);
      });
      if(rebuilt.children.length)imported.replaceWith(rebuilt);
    }
    const journey=this.querySelector('#asa-processo');
    if(journey){const steps=journey.querySelectorAll('article.step');if(steps.length){const grid=document.createElement('div');grid.className='asa-steps';steps.forEach(step=>{const card=document.createElement('article');const h=step.querySelector('h3,h2'),paragraphs=step.querySelectorAll('p');if(h){const heading=document.createElement('h3');heading.textContent=h.textContent;card.append(heading);}paragraphs.forEach(p=>card.append(p.cloneNode(true)));grid.append(card);});journey.replaceWith(grid);}}
    this.querySelectorAll('h1').forEach(h=>{const copy=document.createElement('h2');copy.innerHTML=h.innerHTML;h.replaceWith(copy);});
    this.querySelectorAll('p').forEach(p=>{if(!p.textContent.trim()&&!p.querySelector('img,video,iframe'))p.remove();});
    this.querySelectorAll('table').forEach(table=>{table.querySelectorAll('tbody tr').forEach(row=>{if(!row.textContent.trim()&&!row.querySelector('img,input'))row.remove();});if(!table.parentElement.classList.contains('asa-table-scroll')){const wrap=document.createElement('div');wrap.className='asa-table-scroll';wrap.tabIndex=0;wrap.setAttribute('role','region');wrap.setAttribute('aria-label',table.getAttribute('aria-label')||this.closest('.asa-page')?.querySelector('h1')?.textContent||'Tabela');table.before(wrap);wrap.append(table);}});
    const drafts=['camisa-polo-hipismo','jaqueta-feminina-hipismo','manta-hipismo','babyloock-hipismo-competicao'];
    this.querySelectorAll('a').forEach(a=>{const href=a.getAttribute('href')||'';const slug=href.split('/products/')[1]?.split(/[?#/]/)[0];if(drafts.includes(slug)){const title=a.querySelector('h3')?.textContent||a.querySelector('img')?.alt||slug;a.href=(this.dataset.contactUrl||'/pages/fale_conosco')+'?produto='+encodeURIComponent(title);}if(a.target==='_blank')a.rel='noopener noreferrer';if(href.startsWith('javascript:'))a.removeAttribute('href');if(href==='#'){const image=a.querySelector('img');if(image?.src)a.href=image.src;else a.removeAttribute('href');}});
    this.querySelectorAll('img').forEach(img=>{img.loading='lazy';img.decoding='async';const mark=()=>{if(!img.isConnected||img.nextElementSibling?.classList.contains('asa-media-missing'))return;const fallback=document.createElement('span');fallback.className='asa-media-missing';fallback.textContent=img.alt||'Imagem indispon\u00edvel';img.after(fallback);img.hidden=true;};img.addEventListener('error',mark,{once:true});if(img.complete&&!img.naturalWidth)mark();const a=img.closest('a');if(!a&&!img.closest('.asa-editorial-logos')){const link=document.createElement('a');link.href=img.src;link.dataset.asaZoom='';link.setAttribute('aria-label',this.dataset.zoomLabel);img.before(link);link.append(img);}});
    this.addEventListener('click',event=>{const a=event.target.closest('a[data-asa-zoom]');if(!a||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button!==0)return;event.preventDefault();this.openImage(a);});
  }
  openImage(link){if(!this.dialog){this.dialog=document.createElement('dialog');this.dialog.className='asa-media-dialog';this.dialog.setAttribute('aria-label',this.dataset.zoomLabel);const button=document.createElement('button');button.type='button';button.textContent='×';button.setAttribute('aria-label',this.dataset.closeLabel);button.addEventListener('click',()=>this.dialog.close());const img=document.createElement('img');this.dialog.append(button,img);this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});document.body.append(this.dialog);}const original=link.querySelector('img');const img=this.dialog.querySelector('img');img.src=link.href;img.alt=original?.alt||'';this.dialog.showModal();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["asa-native-contact"] && !Shopify.designMode) return;
  try {
    function asaPrefillContact(root=document,search=location.search){const value=new URLSearchParams(search).get('produto');if(value)root.querySelectorAll('[data-asa-contact-product]').forEach(input=>{if(!input.value)input.value=value.slice(0,180)});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>asaPrefillContact(),{once:true});else asaPrefillContact();
document.addEventListener('shopify:section:load',event=>asaPrefillContact(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["asa-page-enhancements"] && !Shopify.designMode) return;
  try {
    (() => {
  const text = element => (element?.textContent || '').replace(/\s+/g, ' ').trim();
  const normalize = value => value.toLocaleLowerCase('pt-BR');
  const findHeading = (root, label) => [...root.querySelectorAll(':scope > h2,:scope > h3')].find(item => normalize(text(item)) === normalize(label));
  const collectGroup = heading => {
    const nodes = [heading];
    let next = heading.nextElementSibling;
    while (next && !next.matches('h2,h3')) {
      nodes.push(next);
      next = next.nextElementSibling;
    }
    return nodes;
  };
  const enhancePolicy = editorial => {
    if (editorial.querySelector('.asa-policy-grid')) return;
    const sections = [...editorial.querySelectorAll('.section')];
    if (sections.length < 3) return;
    const grid = document.createElement('div');
    grid.className = 'asa-policy-grid';
    sections[0].before(grid);
    sections.forEach(section => grid.append(section));
  };
  const enhanceDetails = editorial => {
    if (editorial.querySelector('.asa-detail-grid')) return;
    const root = editorial.querySelector(':scope > div');
    if (!root) return;
    const segments = [...root.children].filter(item => item.classList.contains('asa-editorial-segment') && (text(item) || item.querySelector('img')));
    if (segments.length < 3) return;
    const intro = segments[0];
    const grid = document.createElement('div');
    grid.className = 'asa-detail-grid';
    intro.after(grid);
    segments.slice(1).forEach(segment => {
      segment.classList.add('asa-detail-card');
      if (segment.querySelector('img')) segment.classList.add('asa-detail-card--media');
      grid.append(segment);
    });
  };
  const enhanceMission = editorial => {
    if (editorial.querySelector('.asa-mvv-native')) return;
    const mission = editorial.querySelector('#sobre-nos');
    const container = mission?.querySelector(':scope > .container') || mission;
    if (!container) return;
    const labels = ['Missão', 'Visão', 'Valores e Atitudes'];
    const headings = labels.map(label => findHeading(container, label));
    if (headings.some(item => !item)) return;
    const grid = document.createElement('div');
    grid.className = 'asa-mvv-native';
    headings[0].before(grid);
    headings.forEach(heading => {
      const card = document.createElement('article');
      collectGroup(heading).forEach(node => card.append(node));
      grid.append(card);
    });
  };
  const enhancePage = page => {
    if (!page || page.dataset.asaEnhanced === 'true') return;
    const editorial = page.querySelector('asa-legacy-page');
    if (!editorial) return;
    page.dataset.asaEnhanced = 'true';
    const headingCount = editorial.querySelectorAll('h2,h3,h4,h5').length;
    if (text(editorial).length > 2200 || headingCount > 8) page.classList.add('asa-page--long');
    const handle = page.dataset.asaPage || '';
    if (handle === 'politica_de_privacidade') enhancePolicy(editorial);
    if (handle === 'detalhes_dos_uniformes') enhanceDetails(editorial);
    if (handle === 'missao_visao_valores') enhanceMission(editorial);
  };
  const run = root => {
    const pages = root.matches?.('.asa-page') ? [root] : [...root.querySelectorAll?.('.asa-page') || []];
    pages.forEach(page => requestAnimationFrame(() => enhancePage(page)));
  };
  const start = root => customElements.whenDefined('asa-legacy-page').then(() => requestAnimationFrame(() => requestAnimationFrame(() => run(root))));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document), { once: true }); else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["asa-page-grid-polish"] && !Shopify.designMode) return;
  try {
    (() => {
  const targetHandles = new Set(['logos_e_escudos', 'golas_dos_uniformes']);

  const getPageHandle = (editorial) => editorial.closest('.asa-page')?.dataset.asaPage || '';

  const getSegmentRoot = (editorial) => {
    const directSegments = [...editorial.children].filter((child) => child.classList?.contains('asa-editorial-segment'));
    if (directSegments.length) return editorial;

    return [...editorial.children].find((child) =>
      [...child.children].some((grandchild) => grandchild.classList?.contains('asa-editorial-segment'))
    ) || editorial;
  };

  const getSegments = (editorial) =>
    [...getSegmentRoot(editorial).children].filter((child) => child.classList?.contains('asa-editorial-segment'));

  const buildCompactCards = (segment) => {
    if (segment.querySelector('.asa-editorial-image, .asa-editorial-gallery, .asa-editorial-cards, table, details')) return;

    const headings = [...segment.children].filter((element) => /^H[2-6]$/.test(element.tagName));
    if (headings.length < 2 || headings.length > 6) return;

    const grid = document.createElement('div');
    grid.className = 'asa-editorial-cards asa-editorial-cards--compact';
    headings[0].before(grid);

    headings.forEach((heading, index) => {
      const card = document.createElement('article');
      const nextHeading = headings[index + 1] || null;
      let node = heading;

      while (node && node !== nextHeading) {
        const next = node.nextElementSibling;
        card.append(node);
        node = next;
      }

      if (card.textContent.trim() || card.querySelector('img')) grid.append(card);
    });
  };

  const buildFeatureGrid = (editorial) => {
    const segments = getSegments(editorial);
    if (!segments.length) return false;

    segments.forEach(buildCompactCards);

    const featureSegments = segments.filter((segment) => {
      const image = segment.querySelector(':scope > .asa-editorial-image');
      const copy = segment.querySelector(':scope > h2, :scope > h3, :scope > h4, :scope > p');
      return Boolean(image && copy);
    });

    if (featureSegments.length < 2) return false;

    featureSegments.forEach((segment) => {
      const next = segment.nextElementSibling;

      if (
        next?.classList.contains('asa-editorial-segment') &&
        !next.querySelector('.asa-editorial-image, .asa-editorial-gallery, table, details') &&
        next.querySelector('.asa-editorial-cards')
      ) {
        const cards = next.querySelector('.asa-editorial-cards');
        segment.append(cards);

        if (!next.textContent.trim() && !next.querySelector('img, video, iframe')) next.remove();
      }

      const figure = segment.querySelector(':scope > .asa-editorial-image');
      if (!figure || segment.querySelector(':scope > .asa-editorial-feature__content')) return;

      const body = document.createElement('div');
      body.className = 'asa-editorial-feature__content';

      [...segment.childNodes].forEach((node) => {
        if (node !== figure) body.append(node);
      });

      segment.append(figure, body);
    });

    const grid = document.createElement('div');
    grid.className = 'asa-editorial-feature-grid';
    featureSegments[0].before(grid);
    featureSegments.forEach((segment) => grid.append(segment));

    return true;
  };

  const process = (editorial) => {
    const handle = getPageHandle(editorial);
    if (!targetHandles.has(handle)) return true;
    if (editorial.dataset.asaSideGrid === 'ready') return true;

    if (!buildFeatureGrid(editorial)) return false;

    editorial.dataset.asaSideGrid = 'ready';
    return true;
  };

  const connect = (root = document) => {
    root.querySelectorAll('asa-legacy-page').forEach((editorial) => {
      if (process(editorial)) return;

      const observer = new MutationObserver(() => {
        if (process(editorial)) observer.disconnect();
      });

      observer.observe(editorial, { childList: true, subtree: true });
    });
  };

  const start = (root = document) => requestAnimationFrame(() => connect(root));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => start(), { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["asa-personalizar-polish"] && !Shopify.designMode) return;
  try {
    (() => {
  const build = (page) => {
    const editorial = page.querySelector('asa-legacy-page');
    if (!editorial || editorial.dataset.asaPersonalizarGallery === 'ready') return false;
    const images = [...editorial.querySelectorAll('.asa-editorial-gallery img,.asa-editorial-image img')];
    if (!images.length) return false;
    const seen = new Set();
    const gallery = document.createElement('div');
    gallery.className = 'asa-personalizar-gallery';
    images.forEach((image) => {
      const src = image.currentSrc || image.src;
      if (!src || seen.has(src)) return;
      seen.add(src);
      const link = document.createElement('a');
      link.href = src;
      link.dataset.asaZoom = '';
      link.setAttribute('aria-label', image.alt || 'Ampliar imagem');
      const copy = image.cloneNode(true);
      copy.loading = 'lazy';
      copy.decoding = 'async';
      link.append(copy);
      gallery.append(link);
    });
    if (!gallery.children.length) return false;
    editorial.prepend(gallery);
    editorial.dataset.asaPersonalizarGallery = 'ready';
    return true;
  };
  const connect = (root = document) => {
    const pages = root.matches?.(".asa-page[data-asa-page='personalizar']")
      ? [root]
      : [...(root.querySelectorAll?.(".asa-page[data-asa-page='personalizar']") || [])];
    pages.forEach((page) => {
      const run = () => build(page);
      if (run()) return;
      const editorial = page.querySelector('asa-legacy-page');
      if (!editorial) return;
      const observer = new MutationObserver(() => {
        if (run()) observer.disconnect();
      });
      observer.observe(editorial,{childList:true,subtree:true});
    });
  };
  const start = (root = document) => customElements.whenDefined('asa-legacy-page').then(() => requestAnimationFrame(() => requestAnimationFrame(() => connect(root))));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), {once:true}); else start();
  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["asa-personalization-polish"] && !Shopify.designMode) return;
  try {
    (() => {
  const removeBetweenFigures = (figure) => {
    let node = figure.nextSibling;
    while (node) {
      const next = node.nextSibling;
      if (node.nodeType === 1 && node.classList?.contains('asa-editorial-image')) break;
      if (node.nodeType === 1 && node.classList?.contains('au-personal-grid')) break;
      node.remove();
      node = next;
    }
  };

  const enhance = (root) => {
    const page = root.matches?.('.asa-page[data-asa-page="personalizacao"]')
      ? root
      : root.querySelector?.('.asa-page[data-asa-page="personalizacao"]');

    if (!page) return;

    const editorial = page.querySelector('asa-legacy-page');
    if (!editorial) return;

    editorial.querySelectorAll('.au-personal-card__body').forEach((body) => body.remove());

    if (editorial.dataset.auPersonalImageOnly === 'true') return;

    const segments = [...editorial.querySelectorAll('.asa-editorial-segment')];
    let changed = false;

    segments.forEach((segment) => {
      const figures = [...segment.children].filter((child) => child.classList?.contains('asa-editorial-image'));
      if (figures.length < 2) return;

      const grid = document.createElement('div');
      grid.className = 'au-personal-grid';
      figures[0].before(grid);

      figures.forEach((figure) => {
        if (!figure.isConnected) return;

        removeBetweenFigures(figure);

        const card = document.createElement('article');
        card.className = 'au-personal-card';
        card.append(figure);
        grid.append(card);
      });

      changed = true;
    });

    if (changed || editorial.querySelector('.au-personal-grid')) {
      editorial.dataset.auPersonalImageOnly = 'true';
      editorial.dataset.auPersonalReady = 'true';
    }
  };

  const start = (root) => {
    requestAnimationFrame(() => {
      enhance(root);

      const page = root.querySelector?.('.asa-page[data-asa-page="personalizacao"]')
        || (root.matches?.('.asa-page[data-asa-page="personalizacao"]') ? root : null);
      const editorial = page?.querySelector('asa-legacy-page');

      if (editorial && editorial.dataset.auPersonalImageOnly !== 'true') {
        const observer = new MutationObserver(() => {
          enhance(root);
          if (editorial.dataset.auPersonalImageOnly === 'true') observer.disconnect();
        });
        observer.observe(editorial,{childList:true,subtree:true});
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => start(document), {once:true});
  } else {
    start(document);
  }

  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["asa-product-copy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('asa-product-copy')) {
  customElements.define('asa-product-copy', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.querySelectorAll('p').forEach(p => {
        if (!p.textContent.trim() && !p.querySelector('img,video,iframe,input,button')) p.remove();
      });
      this.querySelectorAll('table').forEach(table => {
        if (table.parentElement.classList.contains('asa-table-scroll')) return;
        const wrap = document.createElement('div');
        wrap.className = 'asa-table-scroll';
        wrap.tabIndex = 0;
        table.before(wrap);
        wrap.append(table);
      });
      const parents = new Set([...this.querySelectorAll('article')].map(a => a.parentElement));
      parents.forEach(parent => {
        let group;
        [...parent.children].forEach(child => {
          if (child.tagName !== 'ARTICLE') { group = null; return; }
          if (!group) { group = document.createElement('div'); group.className = 'asa-rich-cards'; child.before(group); }
          group.append(child);
        });
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["live-uniformes-legacy-page"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('asa-legacy-page'))customElements.define('asa-legacy-page',class extends HTMLElement{
  connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';if(document.readyState==='loading'){this._ready=()=>this.build();document.addEventListener('DOMContentLoaded',this._ready,{once:true});}else this.build();}
  disconnectedCallback(){document.removeEventListener('DOMContentLoaded',this._ready);if(this.dialog){this.dialog.remove();this.dialog=null;}}
  build(){
    if(!this.isConnected)return;
    this.querySelectorAll('script,style,template,pre.ti-widget,[data-src*="trustindex"]').forEach(n=>n.remove());
    this.querySelectorAll('[style]').forEach(n=>n.removeAttribute('style'));
    this.querySelectorAll('*').forEach(n=>{[...n.attributes].filter(a=>a.name.startsWith('on')).forEach(a=>n.removeAttribute(a.name));});
    const imported=this.querySelector(':scope > .elementor');
    if(imported){
      const rebuilt=document.createElement('div');
      [...imported.children].forEach(segment=>{
        const widgets=[...segment.querySelectorAll('.elementor-widget')].filter(w=>!w.parentElement.closest('.elementor-widget'));
        const out=document.createElement('section');out.className='asa-editorial-segment';if(segment.id)out.id=segment.id;
        let cards=null;
        const appendCard=card=>{if(!cards){cards=document.createElement('div');cards.className='asa-editorial-cards';out.append(cards);}cards.append(card);};
        widgets.forEach(widget=>{
          if(widget.querySelector('.ti-widget,[data-src*="trustindex"]')||widget.classList.contains('elementor-widget-shortcode'))return;
          const accordions=widget.querySelectorAll('.elementor-accordion-item,.single_accourdion');
          if(accordions.length){cards=null;accordions.forEach(item=>{const title=item.querySelector('.elementor-tab-title,.htmega-items-hedding');const answer=item.querySelector('.elementor-tab-content,.accordion-content');if(!title||!answer)return;const details=document.createElement('details');const summary=document.createElement('summary');const copy=title.cloneNode(true);copy.querySelectorAll('svg,i,.elementor-accordion-icon,.accourdion-icon').forEach(n=>n.remove());summary.textContent=copy.textContent.trim();const body=document.createElement('div');body.innerHTML=answer.innerHTML;details.append(summary,body);out.append(details);});return;}
          if(widget.querySelector('.jet-carousel__item')){cards=null;const grid=document.createElement('div');grid.className='asa-editorial-gallery';widget.querySelectorAll('.jet-carousel__item').forEach(item=>{const a=item.querySelector('a'),img=item.querySelector('img'),h=item.querySelector('.jet-carousel__item-title');if(!img)return;const card=document.createElement('article');const link=a?a.cloneNode(false):document.createElement('div');link.append(img.cloneNode(true));if(h){const title=document.createElement('h3');title.textContent=h.textContent.trim();link.append(title);}card.append(link);grid.append(card);});out.append(grid);return;}
          if(widget.querySelector('.exad-logo-carousel')){cards=null;const grid=document.createElement('div');grid.className='asa-editorial-logos';const seen=new Set();widget.querySelectorAll('img').forEach(image=>{let src=image.getAttribute('src');if(!src||seen.has(src))return;seen.add(src);const img=image.cloneNode(true);img.src=src;grid.append(img);});out.append(grid);return;}
          const info=widget.querySelector('.ha-infobox-body,.exad-iconbox-content,.exad-infobox-content');
          if(info){const card=document.createElement('article');card.innerHTML=info.innerHTML;appendCard(card);return;}
          if(widget.classList.contains('ha-step-flow')){const card=document.createElement('article');widget.querySelectorAll('.ha-steps-label,.ha-steps-title,.ha-step-description').forEach(n=>card.append(n.cloneNode(true)));appendCard(card);return;}
          cards=null;
          const body=widget.querySelector(':scope > .elementor-widget-container')||widget;
          if(widget.classList.contains('elementor-widget-image')){const image=body.querySelector('img');if(image){const figure=document.createElement('figure');figure.className='asa-editorial-image';figure.append(image.cloneNode(true));out.append(figure);}return;}
          if(widget.classList.contains('elementor-widget-button')||widget.classList.contains('elementor-widget-exad-exclusive-button')){const link=body.querySelector('a[href]');if(link){const row=document.createElement('div');row.className='asa-editorial-buttons';const copy=link.cloneNode(true);copy.className='asa-action';row.append(copy);out.append(row);}return;}
          [...body.childNodes].forEach(n=>out.append(n.cloneNode(true)));
        });
        if(!widgets.length){[...segment.childNodes].forEach(n=>out.append(n.cloneNode(true)));}
        if(out.textContent.trim()||out.querySelector('img,video,table'))rebuilt.append(out);
      });
      if(rebuilt.children.length)imported.replaceWith(rebuilt);
    }
    const journey=this.querySelector('#asa-processo');
    if(journey){const steps=journey.querySelectorAll('article.step');if(steps.length){const grid=document.createElement('div');grid.className='asa-steps';steps.forEach(step=>{const card=document.createElement('article');const h=step.querySelector('h3,h2'),paragraphs=step.querySelectorAll('p');if(h){const heading=document.createElement('h3');heading.textContent=h.textContent;card.append(heading);}paragraphs.forEach(p=>card.append(p.cloneNode(true)));grid.append(card);});journey.replaceWith(grid);}}
    this.querySelectorAll('h1').forEach(h=>{const copy=document.createElement('h2');copy.innerHTML=h.innerHTML;h.replaceWith(copy);});
    this.querySelectorAll('p').forEach(p=>{if(!p.textContent.trim()&&!p.querySelector('img,video,iframe'))p.remove();});
    this.querySelectorAll('table').forEach(table=>{table.querySelectorAll('tbody tr').forEach(row=>{if(!row.textContent.trim()&&!row.querySelector('img,input'))row.remove();});if(!table.parentElement.classList.contains('asa-table-scroll')){const wrap=document.createElement('div');wrap.className='asa-table-scroll';wrap.tabIndex=0;wrap.setAttribute('role','region');wrap.setAttribute('aria-label',table.getAttribute('aria-label')||this.closest('.asa-page')?.querySelector('h1')?.textContent||'Tabela');table.before(wrap);wrap.append(table);}});
    const drafts=[];
    this.querySelectorAll('a').forEach(a=>{const href=a.getAttribute('href')||'';const slug=href.split('/products/')[1]?.split(/[?#/]/)[0];if(drafts.includes(slug)){const title=a.querySelector('h3')?.textContent||a.querySelector('img')?.alt||slug;a.href=(this.dataset.contactUrl||'/pages/fale_conosco')+'?produto='+encodeURIComponent(title);}if(a.target==='_blank')a.rel='noopener noreferrer';if(href.startsWith('javascript:'))a.removeAttribute('href');if(href==='#'){const image=a.querySelector('img');if(image?.src)a.href=image.src;else a.removeAttribute('href');}});
    this.querySelectorAll('img').forEach(img=>{img.loading='lazy';img.decoding='async';const mark=()=>{if(!img.isConnected||img.nextElementSibling?.classList.contains('asa-media-missing'))return;const fallback=document.createElement('span');fallback.className='asa-media-missing';fallback.textContent=img.alt||'Imagem indispon\u00edvel';img.after(fallback);img.hidden=true;};img.addEventListener('error',mark,{once:true});if(img.complete&&!img.naturalWidth)mark();const a=img.closest('a');if(!a&&!img.closest('.asa-editorial-logos')){const link=document.createElement('a');link.href=img.src;link.dataset.asaZoom='';link.setAttribute('aria-label',this.dataset.zoomLabel);img.before(link);link.append(img);}});
    this.addEventListener('click',event=>{const a=event.target.closest('a[data-asa-zoom]');if(!a||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button!==0)return;event.preventDefault();this.openImage(a);});
  }
  openImage(link){if(!this.dialog){this.dialog=document.createElement('dialog');this.dialog.className='asa-media-dialog';this.dialog.setAttribute('aria-label',this.dataset.zoomLabel);const button=document.createElement('button');button.type='button';button.textContent='×';button.setAttribute('aria-label',this.dataset.closeLabel);button.addEventListener('click',()=>this.dialog.close());const img=document.createElement('img');this.dialog.append(button,img);this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});document.body.append(this.dialog);}const original=link.querySelector('img');const img=this.dialog.querySelector('img');img.src=link.href;img.alt=original?.alt||'';this.dialog.showModal();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["live-uniformes-page-enhancements"] && !Shopify.designMode) return;
  try {
    (() => {
  const text = element => (element?.textContent || '').replace(/\s+/g, ' ').trim();
  const normalize = value => value.toLocaleLowerCase('pt-BR');
  const findHeading = (root, label) => [...root.querySelectorAll(':scope > h2,:scope > h3')].find(item => normalize(text(item)) === normalize(label));
  const collectGroup = heading => {
    const nodes = [heading];
    let next = heading.nextElementSibling;
    while (next && !next.matches('h2,h3')) {
      nodes.push(next);
      next = next.nextElementSibling;
    }
    return nodes;
  };
  const enhancePolicy = editorial => {
    if (editorial.querySelector('.asa-policy-grid')) return;
    const sections = [...editorial.querySelectorAll('.section')];
    if (sections.length < 3) return;
    const grid = document.createElement('div');
    grid.className = 'asa-policy-grid';
    sections[0].before(grid);
    sections.forEach(section => grid.append(section));
  };
  const enhanceDetails = editorial => {
    if (editorial.querySelector('.asa-detail-grid')) return;
    const root = editorial.querySelector(':scope > div');
    if (!root) return;
    const segments = [...root.children].filter(item => item.classList.contains('asa-editorial-segment') && (text(item) || item.querySelector('img')));
    if (segments.length < 3) return;
    const intro = segments[0];
    const grid = document.createElement('div');
    grid.className = 'asa-detail-grid';
    intro.after(grid);
    segments.slice(1).forEach(segment => {
      segment.classList.add('asa-detail-card');
      if (segment.querySelector('img')) segment.classList.add('asa-detail-card--media');
      grid.append(segment);
    });
  };
  const enhanceMission = editorial => {
    if (editorial.querySelector('.asa-mvv-native')) return;
    const mission = editorial.querySelector('#sobre-nos');
    const container = mission?.querySelector(':scope > .container') || mission;
    if (!container) return;
    const labels = ['Missão', 'Visão', 'Valores e Atitudes'];
    const headings = labels.map(label => findHeading(container, label));
    if (headings.some(item => !item)) return;
    const grid = document.createElement('div');
    grid.className = 'asa-mvv-native';
    headings[0].before(grid);
    headings.forEach(heading => {
      const card = document.createElement('article');
      collectGroup(heading).forEach(node => card.append(node));
      grid.append(card);
    });
  };
  const enhancePage = page => {
    if (!page || page.dataset.asaEnhanced === 'true') return;
    const editorial = page.querySelector('asa-legacy-page');
    if (!editorial) return;
    page.dataset.asaEnhanced = 'true';
    const headingCount = editorial.querySelectorAll('h2,h3,h4,h5').length;
    if (text(editorial).length > 2200 || headingCount > 8) page.classList.add('asa-page--long');
    const handle = page.dataset.asaPage || '';
    if (handle === 'politica_de_privacidade') enhancePolicy(editorial);
    if (handle === 'detalhes_dos_uniformes') enhanceDetails(editorial);
    if (handle === 'missao_visao_valores') enhanceMission(editorial);
  };
  const run = root => {
    const pages = root.matches?.('.asa-page') ? [root] : [...root.querySelectorAll?.('.asa-page') || []];
    pages.forEach(page => requestAnimationFrame(() => enhancePage(page)));
  };
  const start = root => customElements.whenDefined('asa-legacy-page').then(() => requestAnimationFrame(() => requestAnimationFrame(() => run(root))));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document), { once: true }); else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["live-uniformes-personalization-image-only"] && !Shopify.designMode) return;
  try {
    (() => {
  const fence = String.fromCharCode(96, 96, 96);

  const removeCodeFences = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      if (!(node.nodeValue || '').includes(fence)) return;
      node.nodeValue = node.nodeValue.replaceAll(fence, '');
    });
  };

  const keepOnlyImageInArticle = (article) => {
    const image = article.querySelector('img');
    if (!image) return;
    const keeper = image.closest('a') || image;
    if (keeper.tagName === 'A') {
      [...keeper.children].forEach((child) => {
        if (child !== image && !child.contains(image)) child.remove();
      });
    }
    [...article.children].forEach((child) => {
      if (child !== keeper && !child.contains(keeper)) child.remove();
    });
  };

  const cleanPersonalization = (page) => {
    const editorial = page.querySelector('asa-legacy-page');
    if (!editorial) return false;

    editorial.querySelectorAll('.asa-editorial-gallery').forEach((gallery) => {
      gallery.classList.add('au-image-only-gallery');
      gallery.querySelectorAll('article').forEach(keepOnlyImageInArticle);
    });

    editorial.querySelectorAll('.asa-editorial-segment').forEach((segment) => {
      if (segment.querySelector('.au-personalization-image-grid')) return;
      const figures = [...segment.children].filter((child) => child.classList?.contains('asa-editorial-image'));
      if (figures.length < 3) return;

      const grid = document.createElement('div');
      grid.className = 'au-personalization-image-grid';
      figures[0].before(grid);
      figures.forEach((figure) => grid.append(figure));

      [...segment.children].forEach((child) => {
        if (child !== grid) child.remove();
      });
    });

    return true;
  };

  const enhance = (root = document) => {
    const scope = root.nodeType === Node.DOCUMENT_NODE ? document : root;
    scope.querySelectorAll?.('.asa-page').forEach(removeCodeFences);

    const pages = scope.matches?.(".asa-page[data-asa-page='personalizacao']")
      ? [scope]
      : [...(scope.querySelectorAll?.(".asa-page[data-asa-page='personalizacao']") || [])];

    pages.forEach((page) => {
      const run = () => {
        removeCodeFences(page);
        cleanPersonalization(page);
      };
      customElements.whenDefined('asa-legacy-page').then(() => {
        requestAnimationFrame(() => requestAnimationFrame(run));
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhance(document), { once: true });
  } else {
    enhance(document);
  }

  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["live-uniformes-personalization-polish"] && !Shopify.designMode) return;
  try {
    (() => {
  const removeBetweenFigures = (figure) => {
    let node = figure.nextSibling;
    while (node) {
      const next = node.nextSibling;
      if (node.nodeType === 1 && node.classList?.contains('asa-editorial-image')) break;
      if (node.nodeType === 1 && node.classList?.contains('au-personal-grid')) break;
      node.remove();
      node = next;
    }
  };

  const enhance = (root) => {
    const page = root.matches?.('.asa-page[data-asa-page="personalizacao"]')
      ? root
      : root.querySelector?.('.asa-page[data-asa-page="personalizacao"]');

    if (!page) return;

    const editorial = page.querySelector('asa-legacy-page');
    if (!editorial) return;

    editorial.querySelectorAll('.au-personal-card__body').forEach((body) => body.remove());

    if (editorial.dataset.auPersonalImageOnly === 'true') return;

    const segments = [...editorial.querySelectorAll('.asa-editorial-segment')];
    let changed = false;

    segments.forEach((segment) => {
      const figures = [...segment.children].filter((child) => child.classList?.contains('asa-editorial-image'));
      if (figures.length < 2) return;

      const grid = document.createElement('div');
      grid.className = 'au-personal-grid';
      figures[0].before(grid);

      figures.forEach((figure) => {
        if (!figure.isConnected) return;

        removeBetweenFigures(figure);

        const card = document.createElement('article');
        card.className = 'au-personal-card';
        card.append(figure);
        grid.append(card);
      });

      changed = true;
    });

    if (changed || editorial.querySelector('.au-personal-grid')) {
      editorial.dataset.auPersonalImageOnly = 'true';
      editorial.dataset.auPersonalReady = 'true';
    }
  };

  const start = (root) => {
    requestAnimationFrame(() => {
      enhance(root);

      const page = root.querySelector?.('.asa-page[data-asa-page="personalizacao"]')
        || (root.matches?.('.asa-page[data-asa-page="personalizacao"]') ? root : null);
      const editorial = page?.querySelector('asa-legacy-page');

      if (editorial && editorial.dataset.auPersonalImageOnly !== 'true') {
        const observer = new MutationObserver(() => {
          enhance(root);
          if (editorial.dataset.auPersonalImageOnly === 'true') observer.disconnect();
        });
        observer.observe(editorial,{childList:true,subtree:true});
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => start(document), {once:true});
  } else {
    start(document);
  }

  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uniformes-legacy-page"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('uniformes-legacy-page'))customElements.define('uniformes-legacy-page',class extends HTMLElement{
  connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';if(document.readyState==='loading'){this._ready=()=>this.build();document.addEventListener('DOMContentLoaded',this._ready,{once:true});}else this.build();}
  disconnectedCallback(){document.removeEventListener('DOMContentLoaded',this._ready);if(this.dialog){this.dialog.remove();this.dialog=null;}}
  build(){
    if(!this.isConnected)return;
    this.querySelectorAll('script,style,template,pre.ti-widget,[data-src*="trustindex"]').forEach(n=>n.remove());
    this.querySelectorAll('[style]').forEach(n=>n.removeAttribute('style'));
    this.querySelectorAll('*').forEach(n=>{[...n.attributes].filter(a=>a.name.startsWith('on')).forEach(a=>n.removeAttribute(a.name));});
    const imported=this.querySelector(':scope > .elementor');
    if(imported){
      const rebuilt=document.createElement('div');
      [...imported.children].forEach(segment=>{
        const widgets=[...segment.querySelectorAll('.elementor-widget')].filter(w=>!w.parentElement.closest('.elementor-widget'));
        const out=document.createElement('section');out.className='uniformes-editorial-segment';if(segment.id)out.id=segment.id;
        let cards=null;
        const appendCard=card=>{if(!cards){cards=document.createElement('div');cards.className='uniformes-editorial-cards';out.append(cards);}cards.append(card);};
        widgets.forEach(widget=>{
          if(widget.querySelector('.ti-widget,[data-src*="trustindex"]')||widget.classList.contains('elementor-widget-shortcode'))return;
          const accordions=widget.querySelectorAll('.elementor-accordion-item,.single_accourdion');
          if(accordions.length){cards=null;accordions.forEach(item=>{const title=item.querySelector('.elementor-tab-title,.htmega-items-hedding');const answer=item.querySelector('.elementor-tab-content,.accordion-content');if(!title||!answer)return;const details=document.createElement('details');const summary=document.createElement('summary');const copy=title.cloneNode(true);copy.querySelectorAll('svg,i,.elementor-accordion-icon,.accourdion-icon').forEach(n=>n.remove());summary.textContent=copy.textContent.trim();const body=document.createElement('div');body.innerHTML=answer.innerHTML;details.append(summary,body);out.append(details);});return;}
          if(widget.querySelector('.jet-carousel__item')){cards=null;const grid=document.createElement('div');grid.className='uniformes-editorial-gallery';widget.querySelectorAll('.jet-carousel__item').forEach(item=>{const a=item.querySelector('a'),img=item.querySelector('img'),h=item.querySelector('.jet-carousel__item-title');if(!img)return;const card=document.createElement('article');const link=a?a.cloneNode(false):document.createElement('div');link.append(img.cloneNode(true));if(h){const title=document.createElement('h3');title.textContent=h.textContent.trim();link.append(title);}card.append(link);grid.append(card);});out.append(grid);return;}
          if(widget.querySelector('.exad-logo-carousel')){cards=null;const grid=document.createElement('div');grid.className='uniformes-editorial-logos';const seen=new Set();widget.querySelectorAll('img').forEach(image=>{let src=image.getAttribute('src');if(!src||seen.has(src))return;seen.add(src);const img=image.cloneNode(true);img.src=src;grid.append(img);});out.append(grid);return;}
          const info=widget.querySelector('.ha-infobox-body,.exad-iconbox-content,.exad-infobox-content');
          if(info){const card=document.createElement('article');card.innerHTML=info.innerHTML;appendCard(card);return;}
          if(widget.classList.contains('ha-step-flow')){const card=document.createElement('article');widget.querySelectorAll('.ha-steps-label,.ha-steps-title,.ha-step-description').forEach(n=>card.append(n.cloneNode(true)));appendCard(card);return;}
          cards=null;
          const body=widget.querySelector(':scope > .elementor-widget-container')||widget;
          if(widget.classList.contains('elementor-widget-image')){const image=body.querySelector('img');if(image){const figure=document.createElement('figure');figure.className='uniformes-editorial-image';figure.append(image.cloneNode(true));out.append(figure);}return;}
          if(widget.classList.contains('elementor-widget-button')||widget.classList.contains('elementor-widget-exad-exclusive-button')){const link=body.querySelector('a[href]');if(link){const row=document.createElement('div');row.className='uniformes-editorial-buttons';const copy=link.cloneNode(true);copy.className='uniformes-action';row.append(copy);out.append(row);}return;}
          [...body.childNodes].forEach(n=>out.append(n.cloneNode(true)));
        });
        if(!widgets.length){[...segment.childNodes].forEach(n=>out.append(n.cloneNode(true)));}
        if(out.textContent.trim()||out.querySelector('img,video,table'))rebuilt.append(out);
      });
      if(rebuilt.children.length)imported.replaceWith(rebuilt);
    }
    const journey=this.querySelector('#asa-processo');
    if(journey){const steps=journey.querySelectorAll('article.step');if(steps.length){const grid=document.createElement('div');grid.className='uniformes-steps';steps.forEach(step=>{const card=document.createElement('article');const h=step.querySelector('h3,h2'),paragraphs=step.querySelectorAll('p');if(h){const heading=document.createElement('h3');heading.textContent=h.textContent;card.append(heading);}paragraphs.forEach(p=>card.append(p.cloneNode(true)));grid.append(card);});journey.replaceWith(grid);}}
    this.querySelectorAll('h1').forEach(h=>{const copy=document.createElement('h2');copy.innerHTML=h.innerHTML;h.replaceWith(copy);});
    this.querySelectorAll('p').forEach(p=>{if(!p.textContent.trim()&&!p.querySelector('img,video,iframe'))p.remove();});
    this.querySelectorAll('table').forEach(table=>{table.querySelectorAll('tbody tr').forEach(row=>{if(!row.textContent.trim()&&!row.querySelector('img,input'))row.remove();});if(!table.parentElement.classList.contains('uniformes-table-scroll')){const wrap=document.createElement('div');wrap.className='uniformes-table-scroll';wrap.tabIndex=0;wrap.setAttribute('role','region');wrap.setAttribute('aria-label',table.getAttribute('aria-label')||this.closest('.uniformes-page')?.querySelector('h1')?.textContent||'Tabela');table.before(wrap);wrap.append(table);}});
    const drafts=[];
    this.querySelectorAll('a').forEach(a=>{const href=a.getAttribute('href')||'';const slug=href.split('/products/')[1]?.split(/[?#/]/)[0];if(drafts.includes(slug)){const title=a.querySelector('h3')?.textContent||a.querySelector('img')?.alt||slug;a.href=(this.dataset.contactUrl||'/pages/fale_conosco')+'?produto='+encodeURIComponent(title);}if(a.target==='_blank')a.rel='noopener noreferrer';if(href.startsWith('javascript:'))a.removeAttribute('href');if(href==='#'){const image=a.querySelector('img');if(image?.src)a.href=image.src;else a.removeAttribute('href');}});
    this.querySelectorAll('img').forEach(img=>{img.loading='lazy';img.decoding='async';const mark=()=>{if(!img.isConnected||img.nextElementSibling?.classList.contains('uniformes-media-missing'))return;const fallback=document.createElement('span');fallback.className='uniformes-media-missing';fallback.textContent=img.alt||'Imagem indispon\u00edvel';img.after(fallback);img.hidden=true;};img.addEventListener('error',mark,{once:true});if(img.complete&&!img.naturalWidth)mark();const a=img.closest('a');if(!a&&!img.closest('.uniformes-editorial-logos')){const link=document.createElement('a');link.href=img.src;link.dataset.asaZoom='';link.setAttribute('aria-label',this.dataset.zoomLabel);img.before(link);link.append(img);}});
    this.addEventListener('click',event=>{const a=event.target.closest('a[data-asa-zoom]');if(!a||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button!==0)return;event.preventDefault();this.openImage(a);});
  }
  openImage(link){if(!this.dialog){this.dialog=document.createElement('dialog');this.dialog.className='uniformes-media-dialog';this.dialog.setAttribute('aria-label',this.dataset.zoomLabel);const button=document.createElement('button');button.type='button';button.textContent='×';button.setAttribute('aria-label',this.dataset.closeLabel);button.addEventListener('click',()=>this.dialog.close());const img=document.createElement('img');this.dialog.append(button,img);this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});document.body.append(this.dialog);}const original=link.querySelector('img');const img=this.dialog.querySelector('img');img.src=link.href;img.alt=original?.alt||'';this.dialog.showModal();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uniformes-page-enhancements"] && !Shopify.designMode) return;
  try {
    (() => {
  const text = element => (element?.textContent || '').replace(/\s+/g, ' ').trim();
  const normalize = value => value.toLocaleLowerCase('pt-BR');
  const findHeading = (root, label) => [...root.querySelectorAll(':scope > h2,:scope > h3')].find(item => normalize(text(item)) === normalize(label));
  const collectGroup = heading => {
    const nodes = [heading];
    let next = heading.nextElementSibling;
    while (next && !next.matches('h2,h3')) {
      nodes.push(next);
      next = next.nextElementSibling;
    }
    return nodes;
  };
  const enhancePolicy = editorial => {
    if (editorial.querySelector('.asa-policy-grid')) return;
    const sections = [...editorial.querySelectorAll('.section')];
    if (sections.length < 3) return;
    const grid = document.createElement('div');
    grid.className = 'asa-policy-grid';
    sections[0].before(grid);
    sections.forEach(section => grid.append(section));
  };
  const enhanceDetails = editorial => {
    if (editorial.querySelector('.asa-detail-grid')) return;
    const root = editorial.querySelector(':scope > div');
    if (!root) return;
    const segments = [...root.children].filter(item => item.classList.contains('uniformes-editorial-segment') && (text(item) || item.querySelector('img')));
    if (segments.length < 3) return;
    const intro = segments[0];
    const grid = document.createElement('div');
    grid.className = 'asa-detail-grid';
    intro.after(grid);
    segments.slice(1).forEach(segment => {
      segment.classList.add('asa-detail-card');
      if (segment.querySelector('img')) segment.classList.add('asa-detail-card--media');
      grid.append(segment);
    });
  };
  const enhanceMission = editorial => {
    if (editorial.querySelector('.asa-mvv-native')) return;
    const mission = editorial.querySelector('#sobre-nos');
    const container = mission?.querySelector(':scope > .container') || mission;
    if (!container) return;
    const labels = ['Missão', 'Visão', 'Valores e Atitudes'];
    const headings = labels.map(label => findHeading(container, label));
    if (headings.some(item => !item)) return;
    const grid = document.createElement('div');
    grid.className = 'asa-mvv-native';
    headings[0].before(grid);
    headings.forEach(heading => {
      const card = document.createElement('article');
      collectGroup(heading).forEach(node => card.append(node));
      grid.append(card);
    });
  };
  const enhancePage = page => {
    if (!page || page.dataset.uniformesEnhanced === 'true') return;
    const editorial = page.querySelector('uniformes-legacy-page');
    if (!editorial) return;
    page.dataset.uniformesEnhanced = 'true';
    const headingCount = editorial.querySelectorAll('h2,h3,h4,h5').length;
    if (text(editorial).length > 2200 || headingCount > 8) page.classList.add('uniformes-page--long');
    const handle = page.dataset.uniformesPage || '';
    if (handle === 'politica_de_privacidade') enhancePolicy(editorial);
    if (handle === 'detalhes_dos_uniformes') enhanceDetails(editorial);
    if (handle === 'missao_visao_valores') enhanceMission(editorial);
  };
  const run = root => {
    const pages = root.matches?.('.uniformes-page') ? [root] : [...root.querySelectorAll?.('.uniformes-page') || []];
    pages.forEach(page => requestAnimationFrame(() => enhancePage(page)));
  };
  const start = root => customElements.whenDefined('uniformes-legacy-page').then(() => requestAnimationFrame(() => requestAnimationFrame(() => run(root))));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document), { once: true }); else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uniformes-personalization-image-only"] && !Shopify.designMode) return;
  try {
    (() => {
  const fence = String.fromCharCode(96, 96, 96);

  const removeCodeFences = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      if (!(node.nodeValue || '').includes(fence)) return;
      node.nodeValue = node.nodeValue.replaceAll(fence, '');
    });
  };

  const keepOnlyImageInArticle = (article) => {
    const image = article.querySelector('img');
    if (!image) return;
    const keeper = image.closest('a') || image;
    if (keeper.tagName === 'A') {
      [...keeper.children].forEach((child) => {
        if (child !== image && !child.contains(image)) child.remove();
      });
    }
    [...article.children].forEach((child) => {
      if (child !== keeper && !child.contains(keeper)) child.remove();
    });
  };

  const cleanPersonalization = (page) => {
    const editorial = page.querySelector('uniformes-legacy-page');
    if (!editorial) return false;

    editorial.querySelectorAll('.uniformes-editorial-gallery').forEach((gallery) => {
      gallery.classList.add('uniformes-image-only-gallery');
      gallery.querySelectorAll('article').forEach(keepOnlyImageInArticle);
    });

    editorial.querySelectorAll('.uniformes-editorial-segment').forEach((segment) => {
      if (segment.querySelector('.uniformes-personalization-image-grid')) return;
      const figures = [...segment.children].filter((child) => child.classList?.contains('uniformes-editorial-image'));
      if (figures.length < 3) return;

      const grid = document.createElement('div');
      grid.className = 'uniformes-personalization-image-grid';
      figures[0].before(grid);
      figures.forEach((figure) => grid.append(figure));

      [...segment.children].forEach((child) => {
        if (child !== grid) child.remove();
      });
    });

    return true;
  };

  const enhance = (root = document) => {
    const scope = root.nodeType === Node.DOCUMENT_NODE ? document : root;
    scope.querySelectorAll?.('.uniformes-page').forEach(removeCodeFences);

    const pages = scope.matches?.(".uniformes-page[data-uniformes-page='personalizacao']")
      ? [scope]
      : [...(scope.querySelectorAll?.(".uniformes-page[data-uniformes-page='personalizacao']") || [])];

    pages.forEach((page) => {
      const run = () => {
        removeCodeFences(page);
        cleanPersonalization(page);
      };
      customElements.whenDefined('uniformes-legacy-page').then(() => {
        requestAnimationFrame(() => requestAnimationFrame(run));
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhance(document), { once: true });
  } else {
    enhance(document);
  }

  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uniformes-personalization-polish"] && !Shopify.designMode) return;
  try {
    (() => {
  const removeBetweenFigures = (figure) => {
    let node = figure.nextSibling;
    while (node) {
      const next = node.nextSibling;
      if (node.nodeType === 1 && node.classList?.contains('uniformes-editorial-image')) break;
      if (node.nodeType === 1 && node.classList?.contains('uniformes-personal-grid')) break;
      node.remove();
      node = next;
    }
  };

  const enhance = (root) => {
    const page = root.matches?.('.uniformes-page[data-uniformes-page="personalizacao"]')
      ? root
      : root.querySelector?.('.uniformes-page[data-uniformes-page="personalizacao"]');

    if (!page) return;

    const editorial = page.querySelector('uniformes-legacy-page');
    if (!editorial) return;

    editorial.querySelectorAll('.uniformes-personal-card__body').forEach((body) => body.remove());

    if (editorial.dataset.uniformesPersonalImageOnly === 'true') return;

    const segments = [...editorial.querySelectorAll('.uniformes-editorial-segment')];
    let changed = false;

    segments.forEach((segment) => {
      const figures = [...segment.children].filter((child) => child.classList?.contains('uniformes-editorial-image'));
      if (figures.length < 2) return;

      const grid = document.createElement('div');
      grid.className = 'uniformes-personal-grid';
      figures[0].before(grid);

      figures.forEach((figure) => {
        if (!figure.isConnected) return;

        removeBetweenFigures(figure);

        const card = document.createElement('article');
        card.className = 'uniformes-personal-card';
        card.append(figure);
        grid.append(card);
      });

      changed = true;
    });

    if (changed || editorial.querySelector('.uniformes-personal-grid')) {
      editorial.dataset.uniformesPersonalImageOnly = 'true';
      editorial.dataset.uniformesPersonalReady = 'true';
    }
  };

  const start = (root) => {
    requestAnimationFrame(() => {
      enhance(root);

      const page = root.querySelector?.('.uniformes-page[data-uniformes-page="personalizacao"]')
        || (root.matches?.('.uniformes-page[data-uniformes-page="personalizacao"]') ? root : null);
      const editorial = page?.querySelector('uniformes-legacy-page');

      if (editorial && editorial.dataset.uniformesPersonalImageOnly !== 'true') {
        const observer = new MutationObserver(() => {
          enhance(root);
          if (editorial.dataset.uniformesPersonalImageOnly === 'true') observer.disconnect();
        });
        observer.observe(editorial,{childList:true,subtree:true});
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => start(document), {once:true});
  } else {
    start(document);
  }

  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
